import axios from 'axios'

export const GET_POSTS_SUCCESS = 'GET_POSTS_SUCCESS';
const getPostsSuccess = (json) => {  
  return {
    type: GET_POSTS_SUCCESS,
    posts: json,
  }
}

export const GET_POSTS_FAILURE = 'GET_POSTS_FAILURE';
const getPostsFailure = (error) => {
  return {
    type: GET_POSTS_FAILURE,
    error
  }
}

export const getPosts = (keyword, sort, start) => {
  return (dispatch) => {

    if (keyword === null || keyword === '') {
      return '';
    }

    let GOOSEARCH_ENDPOINT = `https://${document.domain}/sitesearch-api/`;
    if (document.domain === 'localhost') {
      GOOSEARCH_ENDPOINT = 'https://d33dg2qvywo8t1.cloudfront.net/sitesearch-api/';
    }

    return axios.get(GOOSEARCH_ENDPOINT,
      { params: 
        { Keywords: keyword,
          start: start,
          sort: sort
        }
      })
      .then((results) => {
        let res_json = {}
        if (results.data['goo'] === '') {
          res_json = {
            goo: {
              docs: [],
              hit_num: '0',
              topics: [],
            },
            yahoo: {
              ResultSet: [],
            }
          }
        } else {
          let docs_result = results.data['goo']['docs'];
          let hit_num_result = results.data['goo']['hit_num']['num'];
          let from_result = String(Number(results.data['goo']['range']['from']) + 1);
          let to_result = String(Number(results.data['goo']['range']['to']) + 1);
          let paging_result = results.data['goo']['paging'];
          let prev_result = results.data['goo']['paging']['navi']['prev'];
          let pages_result = results.data['goo']['paging']['navi']['pages'];
          let next_result = results.data['goo']['paging']['navi']['next'];
          let highlightwords_result = results.data['goo']['highlightwords'];
          let topics_result = results.data['goo']['topics'];

          let yahoo_result = results.data['yahoo'];

          res_json = {
            goo: {
              docs: docs_result,
              words: keyword,
              sort: sort,
              hit_num: hit_num_result,
              from: from_result,
              to: to_result,
              paging: paging_result,
              prev: prev_result,
              pages: pages_result,
              next: next_result,
              highlightwords: highlightwords_result,
              topics: topics_result,
            },
            yahoo: yahoo_result,
          }
        }
        dispatch(getPostsSuccess(res_json))
      }).catch(err => 
        dispatch(getPostsFailure(err))
      )
  }
}